//Query parameters

import { isProductionEnv } from './platform';

//in case older browsers like ie
const urlSearchParams = URLSearchParams ? new URLSearchParams(window.location.search) : { get: () => null, keys: () => [], has: () => false };
const params = new Set(urlSearchParams.keys());

export const isDebugModeEnabled = !isProductionEnv() || params.has('debug');

type stringOrNull = string | null;
export const getRedirectUrlFromQuery = ():stringOrNull => urlSearchParams.get('redirectUrl');

export const getQueryParam = urlSearchParams.get.bind(urlSearchParams);
